import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useParams, Navigate } from 'react-router-dom';
import UploadPanel from './components/UploadPanel';
import SalesDayDashboard from './components/SalesDayDashboard';
import WarromComparativo from './components/WarromComparativo';
import SalesDayViewSwitcher from './components/SalesDayViewSwitcher';
import Login from './components/Login';
import UserAdmin from './components/UserAdmin';
import MetasAdmin from './components/MetasAdmin';
import PresenterPanel from './components/PresenterPanel';
import { AuthProvider, useAuth } from './components/AuthContext';
import './App.css';

export const COMPANIES = [
  { slug: 'jmv',     name: 'JMV',     fullName: 'JMV - Tatuapé',              ascCode: '2326126' },
  { slug: 'fix-csp', name: 'FIX CSP', fullName: 'FIX CSP - Porto Alegre CSP', ascCode: 'fix_csp' },
  { slug: 'vip',     name: 'VIP',     fullName: 'VIP - Curitiba',              ascCode: 'vip_cwb' },
  { slug: 'fix-msc', name: 'FIX MSC', fullName: 'FIX MSC - Porto Alegre MSC', ascCode: 'fix_msc' },
  { slug: 'sales-day', name: 'Sales Day', fullName: 'Sales Day — Comparação Geral', ascCode: 'sales_day', isSalesDay: true },
  { slug: 'warrom-comparativo', name: 'Warrom Comparativo', fullName: 'Warrom — Comparativo de Métricas', ascCode: 'warrom_comp', isWarromComp: true },
  { slug: 'sales-day-2', name: 'Sales Day 2.0', fullName: 'Sales Day 2.0 — Warrom + Aprovações', ascCode: 'sales_day_2', isSalesDay2: true },
];

// Botão de sair (mostra o usuário logado).
function LogoutButton() {
  const { user, logout } = useAuth();
  return (
    <button
      onClick={logout}
      title="Sair"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8, padding: '7px 14px', borderRadius: 9,
        border: '1px solid #e2e8f0', background: '#fff', color: '#475569', fontSize: 13, fontWeight: 700,
        cursor: 'pointer', fontFamily: "'Samsung Sharp Sans', 'SamsungOne', sans-serif",
      }}
    >
      <span style={{ color: '#1428A0' }}>{user?.nome || user?.username}</span>
      <span style={{ opacity: 0.5 }}>· Sair</span>
    </button>
  );
}

function CompanySelector() {
  const navigate = useNavigate();
  return (
    <div className="company-selector-page">
      <div style={{ position: 'fixed', top: 16, right: 18, zIndex: 50 }}><LogoutButton /></div>
      <div className="company-selector-header">
        <h1>Up&Help</h1>
        <span>Controle Operacional — Samsung</span>
      </div>
      <p className="company-selector-subtitle">Selecione a empresa para acessar o dashboard</p>
      <div className="company-grid">
        {COMPANIES.filter(c => !c.isSalesDay && !c.isWarromComp).map(c => (
          <button
            key={c.slug}
            className={`company-card ${c.isSalesDay ? 'sales-day-card' : ''} ${c.isWarromComp ? 'warrom-comp-card' : ''} ${c.isSalesDay2 ? 'sales-day-2-card' : ''}`}
            onClick={() => navigate(`/${c.slug}`)}
          >
            <span className="company-card-name">{c.name}</span>
            <span className="company-card-full">{c.fullName}</span>
          </button>
        ))}
        <button
          className="company-card"
          onClick={() => navigate('/metas')}
          style={{ borderColor: 'rgba(0,195,178,0.30)' }}
        >
          <span className="company-card-name">Metas</span>
          <span className="company-card-full">Metas por loja (todas as métricas)</span>
        </button>
        <button
          className="company-card"
          onClick={() => navigate('/logins')}
          style={{ borderColor: 'rgba(20,40,160,0.25)' }}
        >
          <span className="company-card-name">Logins</span>
          <span className="company-card-full">Gerenciar acessos (usuários)</span>
        </button>
      </div>
    </div>
  );
}

function SalesDayApp() {
  const navigate = useNavigate();
  return (
    <div className="app">
      <header className="app-header">
        <div className="header-left">
          <button className="back-btn" onClick={() => navigate('/')} title="Voltar">←</button>
          <h1>Sales Day</h1>
          <span className="header-subtitle">Comparação de Aprovações</span>
        </div>
        <div className="header-right"><LogoutButton /></div>
      </header>
      <main className="app-main">
        <SalesDayDashboard />
      </main>
    </div>
  );
}

function WarromComparativoApp() {
  const navigate = useNavigate();
  return (
    <div className="app">
      <header className="app-header">
        <div className="header-left">
          <button className="back-btn" onClick={() => navigate('/')} title="Voltar">←</button>
          <h1>Warrom Comparativo</h1>
          <span className="header-subtitle">Métricas Operacionais por Loja</span>
        </div>
        <div className="header-right"><LogoutButton /></div>
      </header>
      <main className="app-main">
        <WarromComparativo />
      </main>
    </div>
  );
}

function SalesDay2App() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isLoja = user?.role === 'loja';
  return (
    <div className="app">
      <header className="app-header">
        <div className="header-left">
          {!isLoja && <button className="back-btn" onClick={() => navigate('/')} title="Voltar">←</button>}
          <h1>Sales Day 2.0</h1>
          <span className="header-subtitle">Warrom + Aprovações · visão unificada</span>
        </div>
        <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button
            onClick={() => navigate('/metas')}
            title="Definir metas e equipe da loja"
            style={{
              padding: '8px 16px', borderRadius: 9, border: 'none',
              background: '#1428A0', color: '#fff', fontSize: 13.5, fontWeight: 700,
              cursor: 'pointer', fontFamily: "'Samsung Sharp Sans', 'SamsungOne', sans-serif",
              boxShadow: '0 2px 8px rgba(20,40,160,0.25)',
            }}
          >
            {isLoja ? 'Minhas Metas e Equipe' : 'Metas e Equipe'}
          </button>
          <LogoutButton />
        </div>
      </header>
      <main className="app-main">
        <SalesDayViewSwitcher />
      </main>
    </div>
  );
}

function UserAdminApp() {
  const navigate = useNavigate();
  return (
    <div className="app">
      <header className="app-header">
        <div className="header-left">
          <button className="back-btn" onClick={() => navigate('/')} title="Voltar">←</button>
          <h1>Logins</h1>
          <span className="header-subtitle">Gestão de acessos</span>
        </div>
        <div className="header-right"><LogoutButton /></div>
      </header>
      <main className="app-main">
        <UserAdmin />
      </main>
    </div>
  );
}

function MetasApp() {
  const navigate = useNavigate();
  return (
    <div className="app">
      <header className="app-header">
        <div className="header-left">
          <button className="back-btn" onClick={() => navigate('/')} title="Voltar">←</button>
          <h1>Metas</h1>
          <span className="header-subtitle">Metas por loja · Sales Day 2.0</span>
        </div>
        <div className="header-right"><LogoutButton /></div>
      </header>
      <main className="app-main">
        <MetasAdmin />
      </main>
    </div>
  );
}

function CompanyApp() {
  const { company } = useParams();
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = useState(0);

  if (company === 'sales-day') return <SalesDayApp />;
  if (company === 'warrom-comparativo') return <WarromComparativoApp />;
  if (company === 'sales-day-2') return <SalesDay2App />;

  const companyInfo = COMPANIES.find(c => c.slug === company);
  if (!companyInfo) return <Navigate to="/" replace />;

  const handleUploadComplete = () => setRefreshKey(prev => prev + 1);

  // Clicar numa unidade vai DIRETO para o Upload (o dashboard individual foi
  // removido — tudo agora está no Sales Day 2.0).
  return (
    <div className="app">
      <header className="app-header">
        <div className="header-left">
          <button className="back-btn" onClick={() => navigate('/')} title="Trocar empresa">←</button>
          <h1>Upload de Dados</h1>
          <span className="header-subtitle">{companyInfo.name} · envio de planilhas</span>
        </div>
        <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span className="loja-badge">{companyInfo.ascCode} — {companyInfo.fullName}</span>
          <LogoutButton />
        </div>
      </header>

      <main className="app-main">
        <UploadPanel
          onUploadComplete={handleUploadComplete}
          ascCode={companyInfo.ascCode}
          nomeLoja={companyInfo.fullName}
          empresaSlug={companyInfo.slug}
        />
      </main>
    </div>
  );
}

// Splash simples enquanto valida o token.
function Splash() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#F8F9FB', color: '#1428A0', fontWeight: 700, fontSize: 18,
      fontFamily: "'Samsung Sharp Sans', 'SamsungOne', sans-serif",
    }}>Carregando…</div>
  );
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;

  // Não logado → tela de login em qualquer rota.
  if (!user) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  // Loja → Sales Day 2.0 + suas Metas (qualquer outra rota cai no Sales Day).
  if (user.role === 'loja') {
    return (
      <Routes>
        <Route path="/metas" element={<MetasApp />} />
        <Route path="*" element={<SalesDay2App />} />
      </Routes>
    );
  }

  // Superadmin → app completo.
  return (
    <Routes>
      <Route path="/" element={<CompanySelector />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/logins" element={<UserAdminApp />} />
      <Route path="/metas" element={<MetasApp />} />
      <Route path="/apresentador" element={<PresenterPanel />} />
      <Route path="/:company" element={<CompanyApp />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
